// extracted by mini-css-extract-plugin
export default {"container":"journey_container__LRYaN","wrapper":"journey_wrapper__k0Gzp","title":"journey_title__S-kpc","mainbox":"journey_mainbox__hi6ZX","content":"journey_content__oo-2R"};